import React, { useEffect, useState } from "react";
import apiBaseUrl from "../../utils/config";
import authorizationService from "../Authorization/authorizationService";
import DiagnosisCombinerService from "../Authorization/diagnosisCombinerService";
import TooltipInput from "../../NewUPT/ToolTip/TooltipInput";
import TooltipSelect from "../../NewUPT/ToolTip/TooltipSelect";
import SearchPopup from "../popUps/searchPopup"; // assumed reusable component
import "../../NewUPT/registration/searchPopupDesign.css";

const patientAuthorizationService = new authorizationService();
const diagnosisCombinerService = new DiagnosisCombinerService();

const RegisterAuthorization = () => {
  const [form, setForm] = useState({
    patientId: "",
    patientName: "",
    insptId: "",
    referredBy: "",
    authCode: "",
    dayStart: "",
    dayEnd: "",
    visits: "",
    weeklyVisit: "",
    active: "Yes",
    notes: "",
  });

  const [procedureSet, setProcedureSet] = useState([]);
  const [diagnosisSet, setDiagnosisSet] = useState([]);
  const [popupInfo, setPopupInfo] = useState(null); // { target, url }

  useEffect(() => {
    const handleMessage = (event) => {
      const { target, value, displayName } = event.data;
      if (target === "patientId") {
        setForm((f) => ({ ...f, patientId: value, patientName: displayName }));
      } else if (target === "insptId") {
        setForm((f) => ({ ...f, insptId: value }));
      } else if (target === "procedure") {
        setProcedureSet((prev) => [...prev, value]);
      } else if (target === "diagnosis") {
        setDiagnosisSet((prev) => [...prev, value]);
      }
    };
    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);

  const openSearchPopup = (target, endpoint) => {
    const url = `${apiBaseUrl}${endpoint}`;
    setPopupInfo({ target, url });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const authData = {
        patientId: form.patientId,
        insptId: form.insptId,
        referredBy: form.referredBy.trim(),
        authCode: form.authCode.trim(),
        dayStart: form.dayStart,
        dayEnd: form.dayEnd,
        visits: parseInt(form.visits, 10),
        weeklyVisit: form.weeklyVisit,
        active: form.active,
      };

      const authResponse = await patientAuthorizationService.addPatientAuthorization(authData);

      const diagData = {
        authId: authResponse.id,
        procedureSet: procedureSet.join(","),
        diagnosisSet: diagnosisSet.join(","),
        notes: form.notes.trim(),
      };

      await diagnosisCombinerService.saveOrUpdate(diagData);
      alert("Authorization & Diagnosis Registration Successful!");
    } catch (error) {
      alert("Registration Failed: " + error.message);
    }
  };

  return (
    <>
      {popupInfo && (
        <SearchPopup
          target={popupInfo.target}
          url={popupInfo.url}
          onClose={() => setPopupInfo(null)}
        />
      )}
       <div className="form-wrapper">
      <form id="patientAuthorizationRegistrationForm" onSubmit={handleSubmit}>
        <div className="input-container">
          <button
            type="button"
            onClick={() => openSearchPopup("patientId", "/patient/search")}
          >
            Search Patient
          </button>
          <input type="text" value={form.patientName} readOnly placeholder="Selected Patient" />
        </div>

        <div className="input-container">
          <button
            type="button"
            onClick={() => openSearchPopup("insptId", "/inspt/search")}
          >
            Search Inspt
          </button>
        </div>

        <TooltipInput
          type="text"
          id="referredBy"
          placeholder="Enter Referring Doctor"
          tooltip="Doctor or provider who referred the patient."
          value={form.referredBy}
          onChange={(v) => setForm({ ...form, referredBy: v })}
        />

        <TooltipInput
          type="text"
          id="authCode"
          placeholder="Enter Authorization Code"
          tooltip="Unique authorization code."
          value={form.authCode}
          onChange={(v) => setForm({ ...form, authCode: v })}
        />

        <TooltipInput
          type="date"
          id="dayStart"
          placeholder="Select Start Date"
          tooltip="First date of authorization period."
          value={form.dayStart}
          onChange={(v) => setForm({ ...form, dayStart: v })}
        />

        <TooltipInput
          type="date"
          id="dayEnd"
          placeholder="Select End Date"
          tooltip="Last date of authorization period."
          value={form.dayEnd}
          onChange={(v) => setForm({ ...form, dayEnd: v })}
        />

        <TooltipInput
          type="number"
          id="visits"
          placeholder="Enter Number of Visits"
          tooltip="Total number of approved visits."
          value={form.visits}
          onChange={(v) => setForm({ ...form, visits: v })}
        />

        <TooltipInput
          type="number"
          id="weeklyVisit"
          placeholder="Weekly Visit"
          tooltip="Number of times patient can visit per week."
          value={form.weeklyVisit}
          onChange={(v) => setForm({ ...form, weeklyVisit: v })}
        />

        <TooltipSelect
          id="active"
          label="Is the authorization active?"
          value={form.active}
          onChange={(v) => setForm({ ...form, active: v })}
          options={["Yes", "No"]}
        />

        {/* Procedures */}
        <div className="input-container">
          <button
            type="button"
            onClick={() =>
              openSearchPopup("procedure", "/procedureDiagnosis/search?differenceCode=procedure")
            }
          >
            Add Procedure
          </button>
          <div>{procedureSet.map((p, i) => <p key={i}>✔ {p}</p>)}</div>
        </div>

        {/* Diagnoses */}
        <div className="input-container">
          <button
            type="button"
            onClick={() =>
              openSearchPopup("diagnosis", "/procedureDiagnosis/search?differenceCode=diagnosis")
            }
          >
            Add Diagnosis
          </button>
          <div>{diagnosisSet.map((d, i) => <p key={i}>✔ {d}</p>)}</div>
        </div>

        {/* Notes */}
        <div className="input-container">
          <textarea
            placeholder="Enter Notes (Optional)"
            value={form.notes}
            onChange={(e) => setForm({ ...form, notes: e.target.value })}
          />
        </div>

        <button type="submit">Register Authorization & Diagnosis</button>
      </form>
      </div>
    </>
  );
};

export default RegisterAuthorization;
